import React  from 'react'
import { Col, ButtonGroup, DropdownButton, Badge } from 'react-bootstrap'
import ViewButton from './view-button'
import AbsolutePosition from '../../common/absolute-position'
import Date from '../../date/numerical'
import moment from 'moment'


const ReflectionPromptListItem = ({
    item = {},
}) => {
    const STATES = {
        UNKNOWN: 'Unknown state',
        PENDING: 'Pending...',
        ACTIVE: 'Currently Active',
        COMPLETE: 'Concluded!'
    }

    let state = STATES.UNKNOWN

    if (item.startDate && item.endDate) {
        state = STATES.ACTIVE
        if (moment().isAfter(item.endDate, 'day')) {
            state = STATES.COMPLETE
        }
        if (moment().isBefore(item.startDate, 'day')) {
            state = STATES.PENDING
        }
    }
    return (
        <Col xl={12} style={{ paddingTop: '20px'}}>
            <div
                className='noselect'
                style={{ boxShadow: '0px 0px 20px 10px rgb(238, 247, 255)' }}
            >
                <div style={{
                    padding: '20px',
                    flexGrow: '0.8',
                    borderRadius: '5px',
                    border: state===STATES.ACTIVE ? '2px solid rgb(0, 227, 4)' : undefined
                }}>
                    <AbsolutePosition top='30px' right='30px'>
                        <ButtonGroup>
                            <DropdownButton as={ButtonGroup} id={`${item.id}-dropdown`} title=''>
                                <ViewButton itemId={item.id} />
                            </DropdownButton>
                        </ButtonGroup>
                    </AbsolutePosition>
                    
                    <div><h2>{item.name}</h2></div>
                    <div className='text-muted'><Date value={item.startDate} /> - <Date value={item.endDate} /></div>
                    <div>{state}</div>
                    <div style={{ paddingTop: '5px', color: 'black', whiteSpace: 'pre-wrap'}}>{item.description}</div>
                </div>
            </div>
        </Col>
    )
}

export default ReflectionPromptListItem
